// AUTHOR: NANDHAKUMAR
// VERSION: 0.0.1
// LAST EDIT: NANDHAKUMAR
// DATE: 17/09/2025
// DESCRIPTION: QR REPORT PAGE
const QrReportActionTypes = {
	/************* FETCH QR REPORT LIST START ******************* */
	FETCH_QR_REPORT_START: 'fetch_qr_report_start',
	FETCH_QR_REPORT_SUCCESS: 'fetch_qr_report_success',
	FETCH_QR_REPORT_FAILURE: 'fetch_qr_report_failure',
	FETCH_QR_REPORT_RESPONSE_RESET: 'fetch_qr_report_response_reset',
	FETCH_QR_REPORT_RESPONSE_CHANGED: 'fetch_qr_report_response_changed',
	/************* FETCH QR REPORT LIST END ******************* */
};
export default QrReportActionTypes;
